import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const GroupIcon = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3332 14.1667V15.8333H1.6665V14.1667C1.6665 14.1667 1.6665 10.8333 7.49984 10.8333C13.3332 10.8333 13.3332 14.1667 13.3332 14.1667ZM10.4165 6.25001C10.4165 5.67315 10.2454 5.10924 9.92496 4.6296C9.60447 4.14995 9.14895 3.77612 8.616 3.55536C8.08305 3.33461 7.4966 3.27685 6.93082 3.38939C6.36505 3.50193 5.84535 3.77971 5.43744 4.18762C5.02954 4.59552 4.75175 5.11522 4.63921 5.681C4.52667 6.24677 4.58443 6.83322 4.80519 7.36617C5.02594 7.89912 5.39978 8.35464 5.87942 8.67513C6.35907 8.99562 6.92298 9.16668 7.49984 9.16668C8.27339 9.16668 9.01525 8.85939 9.56223 8.3124C10.1092 7.76542 10.4165 7.02356 10.4165 6.25001ZM13.2832 10.8333C13.7955 11.2298 14.2146 11.7337 14.5112 12.3096C14.8078 12.8855 14.9746 13.5194 14.9998 14.1667V15.8333H18.3332V14.1667C18.3332 14.1667 18.3332 11.1417 13.2832 10.8333ZM12.4998 3.33334C11.9263 3.33068 11.3655 3.50212 10.8915 3.82501C11.3977 4.53229 11.6699 5.38025 11.6699 6.25001C11.6699 7.11977 11.3977 7.96773 10.8915 8.67501C11.3655 8.9979 11.9263 9.16934 12.4998 9.16668C13.2734 9.16668 14.0153 8.85939 14.5622 8.3124C15.1092 7.76542 15.4165 7.02356 15.4165 6.25001C15.4165 5.47646 15.1092 4.7346 14.5622 4.18762C14.0153 3.64063 13.2734 3.33334 12.4998 3.33334Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default GroupIcon;
